import { NavigateOptions, useNavigate } from "react-router-dom";
import useIsInappWebview from "./useIsInappWebview";
import { sendMessage } from "utils/webview";
import { compareVersions } from "../logic/logics_common";
import useGetDeviceInfo from "./useGetDeviceInfo";

type UnifiedNavigateOptions = {
  replace?: boolean;
  state?: NavigateOptions["state"];
  type?: "modal" | "card" | "transparentModal";
  gestureEnabled?: boolean;
  animation?: "none" | "default" | "slide_from_right" | "slide_from_bottom";
  webNavigationInOldVersion?: boolean; // 앱이지만 routerNavigate 로 동작 시킴 (구버전 대응)
};

export default function useUnifiedNavigate() {
  const routerNavigate = useNavigate();
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  function unifiedNavigate(path: string, options: UnifiedNavigateOptions = {}) {
    const { replace, type, state, gestureEnabled, animation } = options;

    if (isInappWebview) {
      const url = `${window.location.origin}${path}`;

      if (compareVersions(appVersion, "1.1.44") >= 0) {
        sendMessage(
          JSON.stringify({
            event: "open_screen",
            params: {
              url: url,
              type: type || "card",
              gestureEnabled: gestureEnabled,
              animation: animation,
              replace: replace,
            },
          })
        );
      } else {
        if (options.webNavigationInOldVersion) {
          routerNavigate(path, { replace: replace, state: state });
        } else {
          sendMessage(
            JSON.stringify({
              event: "open_modal",
              params: {
                url: url,
                type: "transparentModal",
              },
            })
          );
        }
      }

      return;
    } else {
      routerNavigate(path, { replace: replace, state: state });
      return;
    }
  }

  return unifiedNavigate;
}
